import { getStatusInfo, type ValidationStatus } from '../lib/status';

interface StatusBadgeProps {
  status: ValidationStatus;
  size?: 'sm' | 'md';
}

export function StatusBadge({ status, size = 'sm' }: StatusBadgeProps) {
  const info = getStatusInfo(status);

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${info.bgColor} ${info.textColor} ${
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm'
      }`}
    >
      <span>{info.icon}</span>
      <span>{info.label}</span>
    </span>
  );
}
